export const useNotificationHelpers = () => {
    const { pushSuccess, pushError, pushInfo } = useNotifications();
    const timeout = 5500;

    const hfpPushSuccess = (message: string) => {
        pushSuccess(message, { timeout: timeout });
    };

    const hfpPushError = (message: string) => {
        pushError(message, { timeout: timeout });
    };

    const hfpPushInfo = (message: string) => {
        pushInfo(message, { timeout: timeout });
    };

    return {
        hfpPushSuccess,
        hfpPushError,
        hfpPushInfo
    };
};
